import React, { createContext, useContext, useState } from "react";

const SETTINGS_KEY = "idm-dashboard-settings";

export type AppSettings = {
    showTechnicalNames: boolean;
    descriptionsExpanded: boolean;
};

const defaults: AppSettings = {
    showTechnicalNames: false,
    descriptionsExpanded: true,
};

type SettingsContextType = {
    settings: AppSettings;
    update: (patch: Partial<AppSettings>) => void;
};

const SettingsContext = createContext<SettingsContextType>({
    settings: defaults,
    update: () => {},
});

export function SettingsProvider({ children }: { children: React.ReactNode }) {
    const [settings, setSettings] = useState<AppSettings>(() => {
        try {
            const raw = localStorage.getItem(SETTINGS_KEY);
            return raw ? { ...defaults, ...JSON.parse(raw) } : defaults;
        } catch {
            return defaults;
        }
    });

    function update(patch: Partial<AppSettings>) {
        setSettings(prev => {
            const next = { ...prev, ...patch };
            localStorage.setItem(SETTINGS_KEY, JSON.stringify(next));
            return next;
        });
    }

    return (
        <SettingsContext.Provider value={{ settings, update }}>
            {children}
        </SettingsContext.Provider>
    );
}

export function useSettings() {
    return useContext(SettingsContext);
}